<template>
  <v-container grid-list-xl>
    <v-btn @click="showAddUserDialog = true">Add user</v-btn>
    <v-text-field
      v-model="userEmail"
      label="Search for user"
      hint="Email"
      type="email"
      append-icon="search"
      @keypress.enter="search"
      @click:append="search"
      :loading="searching"
    />

    <add-user-dialog v-model="showAddUserDialog" />

    <pre class="mt-3 user-info" v-if="user">
      {{ user }}
    </pre>
  </v-container>
</template>

<script>
import AddUserDialog from './AddUserDialog.vue'

export default {
  name: 'AdminPage',
  components: {
    AddUserDialog
  },
  data: () => ({
    showAddUserDialog: false,
    user: null,
    userEmail: '',
    searching: false
  }),
  methods: {
    async search() {
      this.searching = true
      const token = this.$store.getters.accessToken
      const response = await fetch(
        `${process.env.VUE_APP_API_URL}/users?email=${encodeURIComponent(
          this.userEmail
        )}`,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      )

      let user
      if (response.ok) {
        user = await response.json()
      }
      this.user = Array.isArray(user) ? user[0] : null
      this.searching = false
    }
  }
}
</script>

<style>
.user-info {
  user-select: text;
}
</style>
